export default [
  {
    title: 'Profile',
    icon: 'UserIcon',
    children: [
      {
        title: 'Customer',
        children: [
          {
            title: 'All Customers',
            route: 'customer-list',
          },
          {
            title: 'Type',
            route: 'customer-types',
          },
          {
            title: 'Group',
            route: 'customer-groups',
          },
        ],
      },
      {
        title: 'Vendors',
        children: [
          {
            title: 'All Vendors',
            route: 'vendor-list',
          },
          {
            title: 'Type',
            route: 'vendor-types',
          },
          {
            title: 'Group',
            route: 'vendor-groups',
          },
        ],
      },
      {
        title: 'Employee',
        children: [
          {
            title: 'All Employees',
            route: 'employee-list',
          },
          {
            title: 'Department',
            route: 'employee-department',
          },
          {
            title: 'Designation',
            route: 'employee-designation',
          },
        ],
      },
    ],
  },
];
